if (typeof RecentlyViewedProducts !== "function") {
	class RecentlyViewedProducts extends HTMLElement {

		constructor() {

			super();

      this.loadProductsFromLocalStorage = () => {

        this.savedProducts = localStorage.getItem('recentlyViewedProducts');
        
        if ( this.savedProducts ) {

          // Respect the products_limit set in section settings (via data-limit attribute on wrapper)
          const sectionWrapper = this.closest('[data-recently-viewed-limit]');
          const limit = sectionWrapper ? parseInt(sectionWrapper.dataset.recentlyViewedLimit, 10) : 8;

          let productsDOM = ``;
          const products = JSON.parse(this.savedProducts);
          products.reverse().slice(0, limit).forEach(product => {
            productsDOM += product.product_item_markup;
          }); 

          const sectionTemplate = this.querySelector('template')
          const section = sectionTemplate.content.cloneNode(true);
          section.querySelector('[data-js-recently-viewed-products-container]').innerHTML = productsDOM;

          // --- FIX 1: skeleton ---
          // Markup-ul cardului (din localStorage) are pe <product-variants> atributul
          // data-enable-skeleton="true", dar wrapper-ul `.has-skeleton` si template-ul de
          // skeleton fac parte din grila nativa, NU din cardul capturat. In init()
          // (component-product-form.js) se face this.closest('.has-skeleton').querySelector(...)
          // care intoarce null aici -> crash -> variant picker-ul nu se mai leaga deloc.
          // Eliminam atributul cat markup-ul e inca intr-un fragment neconectat.
          section.querySelectorAll('product-variants[data-enable-skeleton]').forEach(elm => {
            elm.removeAttribute('data-enable-skeleton');
          });
          // --- /FIX 1 ---

          this.append(section);
          sectionTemplate.remove();

          this.querySelector('css-slider').destroySlider();
          this.querySelector('css-slider').initSlider();

          // --- FIX 2: deblocare dropdown variante ---
          // css-slider face preventDefault() pe pointerdown/mousedown (pentru drag),
          // ceea ce impiedica <select>-ul nativ sa-si deschida lista (deschiderea e
          // legata de mousedown, nu de click). Oprim propagarea acestor evenimente
          // de pe select-uri INAINTE sa ajunga la drag-handler-ul slider-ului, astfel
          // comportamentul nativ al select-ului ramane intact, iar drag-ul slider-ului
          // nu mai porneste cand interactionezi cu dropdown-ul.
          this.querySelectorAll('select[data-js-product-variant-container]').forEach(select => {
            ['pointerdown', 'mousedown', 'touchstart'].forEach(evt => {
              select.addEventListener(evt, e => e.stopPropagation());
            });
          });
          // --- /FIX 2 ---

          this.querySelectorAll('form').forEach(elm=>{
            if (elm.querySelector('template')) {
              elm.append(elm.querySelector('template').content.cloneNode(true));
            }
          });
        
        } else {
          this.closest('.mount-recently-viewed-products').style.display = 'none';
        }

      }
      document.addEventListener('DOMContentLoaded', this.loadProductsFromLocalStorage);

		}

	}

	if (typeof customElements.get("recently-viewed-products") == "undefined") {
		customElements.define("recently-viewed-products", RecentlyViewedProducts);
	}

  const recentlyViewedProductsLimit = 10;
  
  const recentyViewedProductExists = (productId, products) => {
    return products.some(product => product.id === productId);
  }
      
  if ( window.location.pathname.includes('/products/') ) {

    const recentlyViewedProduct = window.recentlyViewedProduct;
    const recentlyViewedProductsList = JSON.parse(localStorage.getItem('recentlyViewedProducts')) || [];
    
    if (!recentyViewedProductExists(recentlyViewedProduct.id, recentlyViewedProductsList)) {
      if ( recentlyViewedProductsList.length >= recentlyViewedProductsLimit ) {
        recentlyViewedProductsList.shift();
      }
      recentlyViewedProductsList.push(recentlyViewedProduct);
      localStorage.setItem('recentlyViewedProducts', JSON.stringify(recentlyViewedProductsList));
    }
  
  }
    
}